import Box from "@mui/material/Box";
import { Stack, Typography, Card } from "@mui/material";
import { Link } from "react-router-dom";

import { ReactComponent as IconUser } from "../../images/iconuser.svg";
import { ReactComponent as IconFile } from "../../images/iconFile.svg";
import { ReactComponent as IconDocument } from "../../images/iconDocument.svg";
import { ReactComponent as IconUsers } from "../../images/iconUsers2.svg";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";

const styles = {
  title: {
    fontWeight: "600",
    fontSize: "26px",
    lineHeight: "35px",
    color: "#063F5E",
    marginBottom: "10px",
  },
  subtitle: {
    fontWeight: "400",
    fontSize: "18px",
    lineHeight: "25px",
    marginBottom: "32px",
    color: "#1E729F",
  },
  card: {
    color: "#1E729F",
    border: "1px solid #1E729F",
    cursor: "pointer",
    height: "170px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    padding: "24px 16px",
    borderRadius: "4px",
  },
};

const CardCustom = ({ link = "", icon, title = "" }) => (
  <Link to={link} relative="path">
    <Card sx={styles.card} variant="outlined">
      <Stack width="80px" height="80px">
        {icon}
      </Stack>
      <Typography
        sx={{
          fontWeight: "700",
          fontSize: "18px",
          lineHeight: "25px",
        }}
      >
        {title}
      </Typography>
    </Card>
  </Link>
);

export default function GerenciamentoSistema() {
  return (
    <Box>
      <ButtonGoBack />
      <Box>
        <Typography style={styles.title}>Gerenciamento do sistema</Typography>
        <Typography style={styles.subtitle}>
          Menu de gestão para gerenciamento de configurações do sistema
        </Typography>
      </Box>
      <Box
        sx={{
          gap: "16px 24px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
        }}
      >
        <CardCustom
          title="Profissionais de saúde"
          link="gerenciamento-usuarios"
          icon={<IconUser width="80px !important" height="80px !important" />}
        />
        <CardCustom
          title="Exames"
          icon={<IconFile width="80px !important" height="80px !important" />}
        />
        <CardCustom
          title="Documentos"
          icon={
            <IconDocument width="80px !important" height="80px !important" />
          }
        />
        <CardCustom
          title="Equipe"
          icon={<IconUsers width="80px !important" height="80px !important" />}
        />
      </Box>
    </Box>
  );
}
